import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, BookOpen, Crown } from "lucide-react";

export default function SeriesDetail() {
  const { id } = useParams();
  const [series, setSeries] = useState(null);
  useEffect(() => {
    api.get(`/series/${id}`).then(r => setSeries(r.data)).catch(() => setSeries(null));
  }, [id]);
  if (!series) return <div className="max-w-3xl mx-auto px-4 py-16 text-slate-500">Loading series…</div>;
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 md:py-16">
      <Link to="/series" className="inline-flex items-center gap-2 text-xs text-slate-500 hover:text-amber-300 mb-8"><ArrowLeft className="h-3.5 w-3.5" /> All series</Link>
      <div className="mb-10">
        <div className="flex items-center gap-3 mb-3">
          {series.is_founding && (
            <span className="inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-widest px-2 py-1 rounded-full bg-amber-500/15 border border-amber-500/40 text-amber-300">
              <Crown className="h-3 w-3" /> Founding series
            </span>
          )}
          <span className="font-mono text-[11px] uppercase tracking-widest text-slate-500">by {series.author_name}</span>
        </div>
        <h1 className="font-serif text-4xl md:text-5xl font-bold tracking-tight">{series.title}</h1>
        <p className="mt-4 text-slate-400 max-w-2xl">{series.description}</p>
      </div>
      {(series.stories || []).length === 0 ? (
        <div className="rounded-2xl border border-dashed border-white/10 p-10 text-center text-slate-500">
          No stories in this series yet.
        </div>
      ) : (
        <div className="space-y-3">
          {series.stories.map((s, i) => (
            <Link key={s.story_id} to={`/story/${s.story_id}`} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-[#0F1117] p-5 glow-hover">
              <div className="font-mono text-amber-300 text-lg font-bold w-8">{String(i+1).padStart(2, "0")}</div>
              <div className="flex-1 min-w-0">
                <div className="font-serif text-lg font-semibold truncate">{s.title}</div>
                <div className="text-xs text-slate-400 line-clamp-1">{s.tagline}</div>
              </div>
              <BookOpen className="h-4 w-4 text-slate-500" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
